export const getTitle = ({
  nickName,
  shopName,
  isWearista,
  itemName,
  categoryName,
  childCategoryName,
}: {
  nickName: string
  shopName?: string
  isWearista: boolean
  itemName?: string
  categoryName: string
  childCategoryName?: string
}): string => {
  // WEARISTAの場合ショップ名はつけない
  const userName =
    shopName && !isWearista ? `${nickName}（${shopName}）` : nickName
  const adjustedUserName = userName !== '' ? `${userName}の` : ''
  const adjustedCategoryName = childCategoryName ?? categoryName

  if (itemName)
    return `${adjustedUserName}${adjustedCategoryName}「${itemName}」を使ったコーディネート`
  return `${adjustedUserName}${adjustedCategoryName}を使ったコーディネート`
}
